import { useLayoutEffect } from 'react';

// React Router 6 does not reset scroll and there is no data router here for
// <ScrollRestoration>. Layout effect so it lands before paint.
export default function useScrollToTop() {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);
}
